import { SOURCE_CONFIGURATION, SOURCE_CONFIGURATIONS } from '@mm/api-routes';
import { SourceConfiguration } from '@mm/state/model/SignalModel';
import AuthenticatedController from './AuthenticatedController';

export default class SignalSourceConfigurationsController extends AuthenticatedController {
  static async getAll(configurationId: number) {
    return super.get(SOURCE_CONFIGURATIONS(configurationId));
  }

  static async update(
    data: Partial<SourceConfiguration> & { id: number },
  ): Promise<SourceConfiguration> {
    return super.put(SOURCE_CONFIGURATION(data.id), data);
  }
}
